// The cmx-machine chassis from the landing, built from the size the account has (PZ13 in landing/fx.ts):
// one 2 core + 8 GB pair per column, a drive bay lit per 100 GB.

import { useEffect, useRef } from 'react';
import { PZ13 } from './landing/fx';

export function MachineArt({ cpu = 4, mem = 16, sto = 100 }: { cpu?: number; mem?: number; sto?: number }) {
  const ref = useRef<SVGSVGElement>(null);
  useEffect(() => {
    if (ref.current) PZ13.set(ref.current, { cpu, mem, sto });
  }, [cpu, mem, sto]);
  return <svg ref={ref} className="machine-art" aria-hidden="true" focusable="false" />;
}
